import { normalizeAppLangCode } from '../core/i18n.js';

/**
 * First-paint UI strings before `fetchLocalePack` resolves.
 * Keep EN/ES key-aligned; values mirror locale pack.json for chrome
 * visible at cold start (dock, onboarding, backpack, tree-growing).
 * Regenerated by `npm run locales:pack` (scripts/regen-boot-stubs.mjs).
 */

const ES_UI_BOOT_STUB = {
    a11yPrefsTitle: "Accesibilidad",
    arcadeHealthyMsg: "Todas las memorias están frescas.",
    arcadeHealthyTitle: "¡Jardín Saludable!",
    arcadeTabCare: "Cuidados",
    arcadeTabStorage: "Datos",
    arcadeWaterBtn: "Regar",
    arcadeWaterHere: "Regar Aquí",
    arcadeWateringMission: "Misión de Riego",
    authUsernameRequired: "Escribe un nombre de usuario primero.",
    cancel: "Cancelar",
    careDueReminder: "Tienes {count} cuidados pendientes.",
    careHealth: "vitalidad",
    careInInterval: "en pausa",
    careNextInDays: "Próximo riego en {days} días.",
    carePlaylistEmpty: "No hay cuidados pendientes en este módulo.",
    careReviewedToday: "regados hoy",
    certificatesTagline: "Logros y diplomas",
    certificatesTitle: "Certificados",
    close: "Cerrar",
    dialogOkButton: "Entendido",
    gameDefaultStudentName: "Estudiante",
    gameDefaultTitle: "Juego",
    gameEstablishingUplink: "Preparando modo dinámico…",
    gameLoadingCartridge: "Cargando cartucho…",
    gameReadingTree: "Leyendo el árbol de conocimiento… ({count} lecciones)",
    gameSessionComplete: "Sesión completada",
    gardenEmpty: "Termina un módulo (carpeta) del mapa para plantar una semilla aquí.",
    gardenShopAlreadyOwned: "Ya lo tienes en el jardín.",
    gardenShopBalance: "disponibles",
    gardenShopBirdhouse: "Nido",
    gardenShopButterfly: "Mariposa",
    gardenShopDesc: "Gasta lúmenes en decoración o paraguas. Lo cosmético no da ventajas de estudio; el paraguas sí protege tu racha.",
    gardenShopEquip: "Poner",
    gardenShopEquipped: "Puesto",
    gardenShopEquippedToast: "Decoración colocada en tu jardín.",
    gardenShopFireflies: "Luciérnagas",
    gardenShopFountain: "Fuente",
    gardenShopInsufficient: "Te faltan lúmenes. Sigue estudiando.",
    gardenShopLantern: "Farol",
    gardenShopLegend: "Compra una decoración y la verás moverse en el fondo de la app.",
    gardenShopMaxShields: "Ya tienes el máximo de paraguas.",
    gardenShopMushroom: "Seta",
    gardenShopPurchased: "¡Nueva decoración para tu jardín!",
    gardenShopPurchasedShield: "¡Paraguas añadido a tu mochila!",
    gardenShopShieldOwned: "{n}/{max}",
    gardenShopStreakShield: "Paraguas",
    gardenShopTitle: "Tienda del jardín",
    gardenShopUnequip: "Quitar",
    gardenShopUnequippedToast: "Decoración retirada del jardín.",
    gardenVitalityBright: "Luminoso",
    gardenVitalityDawn: "Amanecer",
    gardenVitalityRadiant: "Radiante",
    gardenVitalityRest: "Reposo",
    gardenVitalitySeedling: "Brote",
    gardenVitalityWarm: "Cálido",
    languageTitle: "Idioma",
    lessonFinished: "COMPLETADO ✓",
    loading: "Cargando…",
    lockedCert: "Aún no desbloqueado",
    lumens: "Lúmenes",
    lumensBadgeHint: "Luz del bosque. Gástala en decoración (Arcade → Cuidados).",
    lumensBadgeLabel: "Lúmenes",
    menuSectionApp: "Aplicación",
    menuSectionCommunity: "Comunidad",
    menuSectionContent: "Contenido",
    menuSectionTools: "Herramientas",
    mochilaCareAllClear: "El bosque está tranquilo. Sigue estudiando para ganar lúmenes ☀️",
    moreMenuRowAboutSub: "App y créditos",
    moreMenuRowCertificates: "Logros",
    moreMenuRowCertificatesSub: "Diplomas e hitos",
    moreMenuRowDownloadSub: "Opcional · mismo Arborito",
    moreMenuRowForumSub: "Temas y mensajes por zona del árbol",
    moreMenuRowSources: "Cursos",
    moreMenuRowSourcesSub: "Los tuyos o de la red",
    navAbout: "Acerca de",
    navArcade: "Arcade",
    navBack: "Atrás",
    navCertificates: "Logros",
    navCommunity: "Comunidad",
    navConstruct: "Modo Construcción",
    navConstructExit: "Salir del modo construcción",
    navForum: "Foro",
    navHome: "Inicio",
    navManual: "Guía de Arborito",
    navMore: "Más",
    navProfile: "Perfil",
    navSage: "Preguntar al Sabio",
    navSageDock: "Sabio",
    navSearch: "Buscar",
    navSources: "Cursos",
    noResults: "No se encontraron resultados",
    noTreesBtnSources: "Cursos",
    onboardingAccessibilityButton: "Accesibilidad",
    onboardingAccountEntryLink: "Tengo una cuenta en línea",
    onboardingAdvancing: "Cargando…",
    onboardingAppFootLink: "App",
    onboardingBack: "Volver",
    onboardingBetaWarningHead: "Alpha {version}",
    onboardingContinue: "Continuar",
    onboardingGithubCollab: "Colaborar en GitHub",
    onboardingJustExploreCta: "Elegir qué estudiar",
    onboardingLanguage: "Idioma",
    onboardingLaterCta: "Sin cuenta por ahora",
    onboardingLocalOnlyConfirmBody: "Arborito quedará muy limitado: sin catálogo en línea, códigos de compartir, foros, sincronización ni publicar. Solo árboles en este dispositivo e importación manual. Puedes activar la red más tarde desde Privacidad y datos.",
    onboardingLocalOnlyConfirmButton: "Sí, solo local",
    onboardingLocalOnlyConfirmSpotlight: "Sin conexión a la red",
    onboardingLocalOnlyConfirmTitle: "¿Modo solo local?",
    onboardingLocalOnlyLink: "Continuar sin red (solo local)",
    onboardingLocalOnlyPromptBody: "Arborito quedará muy limitado: sin catálogo en línea, códigos, foros, sincronización ni publicar. Para confirmar, escribe sololocal.",
    onboardingLocalOnlyPromptMismatch: "La confirmación no coincide.",
    onboardingLocalOnlyPromptPlaceholder: "sololocal",
    onboardingLocalOnlyPromptWord: "sololocal",
    onboardingLocalOnlyQuietLink: "Forzar modo offline",
    onboardingLoginSigningInBanner: "Conectando con la red… puede tardar unos segundos. Por favor no cierres ni recargues la pestaña.",
    onboardingLoginSigningInButton: "Iniciando sesión…",
    onboardingMiniTopicBio: "Biología",
    onboardingMiniTopicCode: "Computación",
    onboardingMiniTopicCook: "Cocina",
    onboardingMiniTopicLang: "Idiomas",
    onboardingMiniTopicMore: "Infinitas posibilidades",
    onboardingNetworkAcceptNote: "Al continuar aceptas la política de privacidad y activas la red pública. Puedes cambiarlo en Privacidad y datos.",
    onboardingNetworkAddRelay: "Añadir servidor",
    onboardingNetworkAddRelayPlaceholder: "wss://…",
    onboardingNetworkBundleHint: "Usa el paquete recomendado para que profesores y alumnos vean el mismo curso.",
    onboardingNetworkMinOne: "Elige al menos un servidor o desactiva la red pública.",
    onboardingOptionalAppLink: "App instalada (opcional) ›",
    onboardingPrivacyHeading: "Privacidad",
    onboardingPrivacyShortLink: "Privacidad",
    onboardingRegisterCreatingBanner: "Creando tu cuenta… esto puede tardar unos segundos. Por favor no cierres ni recargues la pestaña.",
    onboardingRegisterCreatingButton: "Creando cuenta…",
    onboardingSessionChecking: "Comprobando…",
    onboardingSessionContinue: "Continuar",
    onboardingSessionSubtitle: "Usa tu cuenta en línea para sincronizar el progreso entre dispositivos.",
    onboardingSessionTitle: "Iniciar sesión",
    onboardingStepLabel: "Paso {n} de {total}",
    onboardingTagline: "Aprender gratis",
    onboardingWelcome: "Bienvenido a Arborito",
    privacyTitle: "Política de Privacidad (Datenschutz)",
    profileSheetTagline: "Identidad, cuenta y herramientas",
    progressBackpackTagline: "Lo que llevas en el bosque",
    progressLessons: "lecciones",
    progressLessonsLine: "{lessons} lecciones · {modules} módulos",
    progressModules: "módulos",
    progressNoAchievements: "Aún no hay logros.",
    progressRingLabel: "Crecimiento",
    progressTitle: "Tu mochila",
    progressViewCerts: "Ver certificados",
    progressWeeklyLine: "Esta semana: {n} lúmenes",
    searchCert: "Buscar certificado...",
    seedsTitle: "Semillas",
    showAll: "Ver todos",
    showEarned: "Mis logros",
    sourceLoad: "Abrir",
    streak: "Racha",
    streakDays: "{n} días",
    streakHint: "Gana lúmenes o repasa un cuidado hoy para mantener la racha",
    streakHintDone: "Hoy ya cuenta. Estudia mañana para sumar otro día",
    streakKept: "¡Racha mantenida!",
    streakNudgeBanner: "Hoy puedes sumar un día a la racha",
    streakShieldEarned: "¡Paraguas ganado! Protege un día sin estudiar.",
    streakShieldHint: "Un paraguas de hojas protege un día sin estudiar",
    streakShieldLabel: "Paraguas",
    streakShieldUsed: "Una hoja paraguas protegió tu racha 🍃",
    streakTodayDone: "Racha hecha",
    streakTodayPending: "Falta racha",
    syncLoginNeedUserSecret: "Ingresa usuario y secreto.",
    syncLoginUsernameTaken: "Ese nombre ya está en uso. Elige otro o inicia sesión con tu contraseña.",
    themeToggle: "Cambiar Tema",
    todayGoal: "Fotosíntesis",
    treeGrowingPleaseWait: "Un momento, por favor",
    treeGrowingShort: "Cargando árbol de conocimiento…",
    treeGrowingTitle: "Preparando tu árbol",
    viewCert: "VER CERTIFICADO",
    xpUnit: "Lúmenes",
};

const EN_UI_BOOT_STUB = {
    a11yPrefsTitle: "Accessibility",
    arcadeHealthyMsg: "All memories are fresh.",
    arcadeHealthyTitle: "Garden is Healthy!",
    arcadeTabCare: "Care",
    arcadeTabStorage: "Data",
    arcadeWaterBtn: "Water",
    arcadeWaterHere: "Water Here",
    arcadeWateringMission: "Watering Mission",
    authUsernameRequired: "Enter a username first.",
    cancel: "Cancel",
    careDueReminder: "You have {count} care items due.",
    careHealth: "health",
    careInInterval: "in interval",
    careNextInDays: "Next care in {days} days.",
    carePlaylistEmpty: "No due care items in this module.",
    careReviewedToday: "watered today",
    certificatesTagline: "Achievements & Diplomas",
    certificatesTitle: "Certificates",
    close: "Close",
    dialogOkButton: "OK",
    gameDefaultStudentName: "Student",
    gameDefaultTitle: "Game",
    gameEstablishingUplink: "Preparing dynamic mode…",
    gameLoadingCartridge: "Loading cartridge…",
    gameReadingTree: "Reading knowledge tree… ({count} lessons found)",
    gameSessionComplete: "Session complete",
    gardenEmpty: "Finish a module (folder) on the map to plant a seed here.",
    gardenShopAlreadyOwned: "You already own this.",
    gardenShopBalance: "available",
    gardenShopBirdhouse: "Birdhouse",
    gardenShopButterfly: "Butterfly",
    gardenShopDesc: "Spend lumens on decoration or leaf shields. Decor is cosmetic only; shields protect your streak.",
    gardenShopEquip: "Place",
    gardenShopEquipped: "Placed",
    gardenShopEquippedToast: "Decoration placed in your garden.",
    gardenShopFireflies: "Fireflies",
    gardenShopFountain: "Fountain",
    gardenShopInsufficient: "Not enough lumens. Keep learning!",
    gardenShopLantern: "Lantern",
    gardenShopLegend: "Buy a decoration and you'll see it animate in the app background.",
    gardenShopMaxShields: "You already have the maximum leaf shields.",
    gardenShopMushroom: "Mushroom",
    gardenShopPurchased: "New garden decoration!",
    gardenShopPurchasedShield: "Leaf shield added to your pack!",
    gardenShopShieldOwned: "{n}/{max}",
    gardenShopStreakShield: "Leaf shield",
    gardenShopTitle: "Garden shop",
    gardenShopUnequip: "Remove",
    gardenShopUnequippedToast: "Decoration removed from your garden.",
    gardenVitalityBright: "Bright",
    gardenVitalityDawn: "Dawn",
    gardenVitalityRadiant: "Radiant",
    gardenVitalityRest: "Rest",
    gardenVitalitySeedling: "Seedling",
    gardenVitalityWarm: "Warm",
    languageTitle: "Language",
    lessonFinished: "COMPLETED ✓",
    loading: "Loading open knowledge map...",
    lockedCert: "Certificate Locked",
    lumens: "lumens",
    lumensBadgeHint: "Garden currency. Spend it in Arcade → Care.",
    lumensBadgeLabel: "Lumens",
    menuSectionApp: "App",
    menuSectionCommunity: "Community",
    menuSectionContent: "Content",
    menuSectionTools: "Tools",
    mochilaCareAllClear: "All caught up. Keep studying to earn lumens ☀️",
    moreMenuRowAboutSub: "App & credits",
    moreMenuRowCertificates: "Achievements",
    moreMenuRowCertificatesSub: "Diplomas & awards",
    moreMenuRowDownloadSub: "Optional · same Arborito",
    moreMenuRowForumSub: "Topics and posts by tree area",
    moreMenuRowSources: "Courses",
    moreMenuRowSourcesSub: "Yours or from the network",
    navAbout: "About",
    navArcade: "Arcade",
    navBack: "Back",
    navCertificates: "Achievements",
    navCommunity: "Community",
    navConstruct: "Construction Mode",
    navConstructExit: "Exit construction",
    navForum: "Forum",
    navHome: "Home",
    navManual: "Arborito Guide",
    navMore: "More",
    navProfile: "Profile & Garden",
    navSage: "Ask the owl",
    navSageDock: "Owl",
    navSearch: "Search",
    navSources: "Courses",
    noResults: "No results found",
    noTreesBtnSources: "Courses",
    onboardingAccessibilityButton: "Accessibility",
    onboardingAccountEntryLink: "I have an online account",
    onboardingAdvancing: "Loading…",
    onboardingAppFootLink: "App",
    onboardingBack: "Back",
    onboardingBetaWarningHead: "Alpha {version}",
    onboardingContinue: "Continue",
    onboardingGithubCollab: "Contribute on GitHub",
    onboardingJustExploreCta: "Choose what to study",
    onboardingLanguage: "Language",
    onboardingLaterCta: "No account for now",
    onboardingLocalOnlyConfirmBody: "Arborito will be very limited: no online catalog, share codes, forums, sync, or publishing. Only trees on this device and manual import. You can enable the network later from Privacy & data.",
    onboardingLocalOnlyConfirmButton: "Yes, local only",
    onboardingLocalOnlyConfirmSpotlight: "No network connection",
    onboardingLocalOnlyConfirmTitle: "Local-only mode?",
    onboardingLocalOnlyLink: "Continue offline (local only)",
    onboardingLocalOnlyPromptBody: "Arborito will be very limited: no online catalog, share codes, forums, sync, or publishing. To confirm, type localonly.",
    onboardingLocalOnlyPromptMismatch: "Confirmation did not match.",
    onboardingLocalOnlyPromptPlaceholder: "localonly",
    onboardingLocalOnlyPromptWord: "localonly",
    onboardingLocalOnlyQuietLink: "Force offline mode",
    onboardingLoginSigningInBanner: "Connecting to the network… this can take a few seconds. Please don't close or reload the tab.",
    onboardingLoginSigningInButton: "Signing in…",
    onboardingMiniTopicBio: "Biology",
    onboardingMiniTopicCode: "Computing",
    onboardingMiniTopicCook: "Cooking",
    onboardingMiniTopicLang: "Languages",
    onboardingMiniTopicMore: "Infinite possibilities",
    onboardingNetworkAcceptNote: "By continuing you accept the privacy policy and enable the public network. You can change this later in Privacy & data.",
    onboardingNetworkAddRelay: "Add server",
    onboardingNetworkAddRelayPlaceholder: "wss://…",
    onboardingNetworkBundleHint: "Use the recommended bundle so teachers and learners see the same course.",
    onboardingNetworkMinOne: "Choose at least one server or turn off the public network.",
    onboardingOptionalAppLink: "Desktop app (optional) ›",
    onboardingPrivacyHeading: "Privacy",
    onboardingPrivacyShortLink: "Privacy",
    onboardingRegisterCreatingBanner: "Creating your account… this can take a few seconds. Please don't close or reload the tab.",
    onboardingRegisterCreatingButton: "Creating account…",
    onboardingSessionChecking: "Checking…",
    onboardingSessionContinue: "Continue",
    onboardingSessionSubtitle: "Use your online account to sync progress across devices.",
    onboardingSessionTitle: "Sign in",
    onboardingStepLabel: "Step {n} of {total}",
    onboardingTagline: "Learn for free",
    onboardingWelcome: "Welcome to Arborito",
    privacyTitle: "Privacy Policy",
    profileSheetTagline: "Identity, account & tools",
    progressBackpackTagline: "Your progress in this knowledge tree",
    progressLessons: "lessons",
    progressLessonsLine: "{lessons} lessons · {modules} modules completed",
    progressModules: "modules",
    progressNoAchievements: "No achievements yet.",
    progressRingLabel: "Branch progress",
    progressTitle: "Your backpack",
    progressViewCerts: "View certificates",
    progressWeeklyLine: "This week: {n} lumens",
    searchCert: "Search certificate...",
    seedsTitle: "Seeds",
    showAll: "Show all",
    showEarned: "My achievements",
    sourceLoad: "Open",
    streak: "Streak",
    streakDays: "{n} days",
    streakHint: "Earn lumens or do a care review today to keep your streak",
    streakHintDone: "Today already counts. Study again tomorrow to add another day",
    streakKept: "Streak Kept!",
    streakNudgeBanner: "You can add a day to your streak today",
    streakShieldEarned: "Leaf shield earned! It protects one missed day.",
    streakShieldHint: "Protects one missed day",
    streakShieldLabel: "Leaf shield",
    streakShieldUsed: "A leaf shield saved your streak 🍃",
    streakTodayDone: "Streak done",
    streakTodayPending: "Streak due",
    syncLoginNeedUserSecret: "Enter username and secret.",
    syncLoginUsernameTaken: "That username is already taken. Pick another or sign in.",
    themeToggle: "Toggle Theme",
    todayGoal: "Photosynthesis",
    treeGrowingPleaseWait: "Please wait",
    treeGrowingShort: "Loading tree…",
    treeGrowingTitle: "Planting your tree",
    viewCert: "VIEW CERTIFICATE",
    xpUnit: "lumens",
};

/** Strings for first paint before `fetchLocalePack` resolves. */
export function bootStubForLang(langCode) {
    const isEs = normalizeAppLangCode(langCode) === 'ES';
    const stub = isEs ? ES_UI_BOOT_STUB : EN_UI_BOOT_STUB;
    return { ...stub };
}

export { ES_UI_BOOT_STUB, EN_UI_BOOT_STUB };
